import { useEffect, useState } from "react";

const NAV = [
  { href: "#weekly", label: "本周汇总" },
  { href: "#recap", label: "近期盘点" },
  { href: "#monthly", label: "本月黑料" },
  { href: "#sectors", label: "题材分栏" },
  { href: "#hot", label: "热度总榜" },
  { href: "#timeline", label: "时间线" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/95 shadow-none border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1240px] px-4 md:px-6 flex items-center justify-between h-16 md:h-[74px]">
        <a href="#top" className="flex items-center gap-2.5 shrink-0">
          <span
            className={`w-9 h-9 rounded-md flex items-center justify-center font-heading text-lg font-black text-background-50 ${
              solid ? "bg-primary-500" : "bg-background-50/90"
            }`}
          >
            料
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-[22px] font-black tracking-tight ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              最新黑料
            </span>
            <span
              className={`text-[11px] font-label mt-0.5 ${
                solid ? "text-foreground-500" : "text-background-200/90"
              }`}
            >
              WEEKLY DOSSIER · 每周更一份
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className={`text-[15px] font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                solid ? "text-foreground-700" : "text-background-50/90"
              }`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#weekly"
            className={`hidden sm:inline-flex whitespace-nowrap items-center gap-2 rounded-md px-4 py-2 text-sm font-semibold transition-colors ${
              solid
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-foreground-900 hover:bg-background-100"
            }`}
          >
            <i className="ri-flashlight-fill w-4 h-4 flex items-center justify-center" />
            去看最新瓜
          </a>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-9 h-9 rounded-md flex items-center justify-center border ${
              solid ? "text-foreground-900 border-background-200" : "text-background-50 border-background-50/40"
            }`}
          >
            <i className={open ? "ri-close-line w-5 h-5" : "ri-menu-3-line w-5 h-5"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <div className="grid grid-cols-2 gap-2">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-200"
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}